const inputType = {
  numeric(name, value, callBack, setError, setErrorMessage) {
    var re = /^[0-9\b]+$/;
    const chars = value.split("");
    const char = chars.pop();
    if (!re.test(char)) {
      setError(true);
      setErrorMessage("این فیلد فقط شامل اعداد می باشد.");
    } else {
      setError(false);
      setErrorMessage("");
    }

    let val = value.replace(/[^\d]+/g, "");

    callBack(name, val);
  },
};

export default inputType;
